import { FAQS } from "@/data/content";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="section">
      <div className="container-x grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <div className="inline-flex items-center gap-2 rounded-full border border-[#0A3161]/15 bg-[#0A3161]/5 px-3 py-1 text-[12px] font-semibold text-[#0A3161]">
            FAQ
          </div>
          <h2 className="mt-4 font-display font-extrabold text-4xl md:text-5xl tracking-tight text-slate-900">
            Answers to <span className="text-[#B31942]">common questions</span>.
          </h2>
          <p className="mt-4 text-slate-600">
            Can't find what you're looking for? Book a free 20-minute counseling call and we'll answer everything.
          </p>
        </div>
        <div className="lg:col-span-8">
          <Accordion type="single" collapsible defaultValue="q-0" className="w-full space-y-3">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`q-${i}`}
                data-testid={`faq-${i}`}
                className="rounded-2xl border border-black/5 bg-white px-5 soft-shadow"
              >
                <AccordionTrigger className="text-left text-[15px] md:text-base font-semibold text-slate-900 hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 leading-relaxed">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
